import { FC } from 'react'
import { DataGrid, GridColDef } from '@mui/x-data-grid'
import { useTheme } from '@mui/system'
import { DashboardActivity } from '../../../types/dashboard.type'
import dayjs from 'dayjs'

export const formatDashboardDate = (value: Date): String => dayjs(value).format('MMM DD, YYYY HH:mm:ss')

interface IProps {
  rows: DashboardActivity[]
}

const columns: GridColDef<DashboardActivity>[] = [
  { field: 'id', headerName: 'ID', width: 90 },
  {
    field: 'timestamp',
    headerName: 'Timestamp',
    sortable: false,
    width: 200,
    valueFormatter: (value) => (typeof value === 'string' ? value : formatDashboardDate(value)),
  },
  {
    field: 'severity',
    headerName: 'Severity',
    sortable: false,
    width: 100,
  },
  {
    field: 'message',
    headerName: 'Message',
    sortable: false,
    flex: 1,
  },
]

const ActivityLog: FC<IProps> = ({ rows }) => {
  const theme = useTheme()

  return (
    <DataGrid
      rows={rows}
      columns={columns}
      initialState={{
        pagination: {
          paginationModel: {
            pageSize: 5,
          },
        },
        columns: {
          columnVisibilityModel: {
            id: false,
          },
        },
      }}
      getRowClassName={(row) => (row.row.color ? `row-${row.row.color}` : '')}
      pageSizeOptions={[5]}
      density="compact"
      slotProps={{
        pagination: {
          sx: {
            '.MuiToolbar-gutters': {
              px: '5px !important',
            },
            '.MuiToolbar-root': {
              height: 36,
            },
          },
        },
      }}
      sx={{
        '& div.MuiDataGrid-columnHeaders > div': {
          background: 'none !important',
        },

        '& .MuiDataGrid-footerContainer': {
          minHeight: 36,
          height: 36,
          paddingY: 0,
        },
        '& .MuiTablePagination-root': {
          minHeight: 36,
        },
        '& .MuiTablePagination-toolbar': {
          minHeight: 36,
          paddingLeft: 8,
          paddingRight: 8,
        },
        '& .row-warning': {
          color: theme.palette.warning.main,
        },
        '& .row-error': {
          color: theme.palette.error.main,
        },
      }}
    />
  )
}

export default ActivityLog
